import { ResponseData } from "./survey.types";
import { Xid } from "@/utils/xid";
import { parseJSON } from "date-fns";

export class Response implements ResponseData {
  readonly id?: string;
  readonly surveyId?: string;
  readonly dateSubmitted?: Date | string;
  readonly result?: any[];
  readonly data?: Record<string, string | Record<string, string>> = {};

  constructor(data: ResponseData, clientSide = true) {
    if (data.id) {
      this.id = data.id;
    } else {
      this.id = Xid.generateId();
    }
    this.surveyId = data.surveyId;
    data.dateSubmitted
      ? (this.dateSubmitted = parseJSON(data.dateSubmitted))
      : (this.dateSubmitted = new Date());
    
    this.result = data.result;

    this.result?.forEach((item) => {
      this.data![item.name] = item.value;
    });

  }
}
